/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getCycleDays } from 'app/entities/cycle-day/cycle-day.reducer';
import { createEntity, getEntity, reset, updateEntity } from './cervix.reducer';

export const CervixUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const cycleDays = useAppSelector(state => state.cycleDay.entities);
  const cervixEntity = useAppSelector(state => state.cervix.entity);
  const loading = useAppSelector(state => state.cervix.loading);
  const updating = useAppSelector(state => state.cervix.updating);
  const updateSuccess = useAppSelector(state => state.cervix.updateSuccess);

  const handleClose = () => {
    navigate(`/cervix${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getCycleDays({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.opening !== undefined && typeof values.opening !== 'number') {
      values.opening = Number(values.opening);
    }
    if (values.firmness !== undefined && typeof values.firmness !== 'number') {
      values.firmness = Number(values.firmness);
    }
    if (values.position !== undefined && typeof values.position !== 'number') {
      values.position = Number(values.position);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...cervixEntity,
      ...values,
      cycleDay: cycleDays.find(it => it.id.toString() === values.cycleDay?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...cervixEntity,
          cycleDay: cervixEntity?.cycleDay?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.cervix.home.createOrEditLabel" data-cy="CervixCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.cervix.home.createOrEditLabel">Create or edit a Cervix</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="cervix-id"
                  label={translate('tinyMedicRestApp.cervix.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.cervix.opening')}
                id="cervix-opening"
                name="opening"
                data-cy="opening"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cervix.firmness')}
                id="cervix-firmness"
                name="firmness"
                data-cy="firmness"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cervix.position')}
                id="cervix-position"
                name="position"
                data-cy="position"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cervix.comments')}
                id="cervix-comments"
                name="comments"
                data-cy="comments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cervix.active')}
                id="cervix-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cervix.draft')}
                id="cervix-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cervix.cursor')}
                id="cervix-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cervix.lastUpdated')}
                id="cervix-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cervix.microSec')}
                id="cervix-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.cervix.timestampEntry')}
                id="cervix-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="cervix-cycleDay"
                name="cycleDay"
                data-cy="cycleDay"
                label={translate('tinyMedicRestApp.cervix.cycleDay')}
                type="select"
              >
                <option value="" key="0" />
                {cycleDays
                  ? cycleDays.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/cervix" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CervixUpdate;
